import { createContext } from 'react'

/**
 * Context containing the app configuration.
 */
export const ConfigContext = createContext()

export default ConfigContext
